<template>
    <div class="pcenter" style="margin-top: 30px;">
      <div :span="24" style="flex-flow: column;" class="pcenter">
        <div><span style="font-size:16px; font-weight: bold;">选择添加的功能组</span></div>
        <div class="pcenter" style="margin-top: 20px; flex-wrap: wrap;">
          <div class="pcenter" style="padding: 10px;" v-for="(subdata,index) in modelgroups" :key="index">
            <GoodsListTemp  @buymodelonlist="buymodel(subdata.id.Int64,subdata.price !== null ? parseInt(subdata.price.String) : 0,subdata.state)" :gid="subdata.id.Int64" :gimg="subdata.modelimg.String" :gname="subdata.mgname.String" :gdes="subdata.mgdes.String" :price="subdata.price !== null ? subdata.price.String : '免费'"  :gbuystate="subdata.state !== null ? subdata.state : 0" :gbuytime="subdata.buytime ? subdata.buytime : ''"></GoodsListTemp>
          </div>
        </div>
      </div>
      <el-dialog :modal="smdialog" title="购买功能" :visible.sync="gbpanelvisible" @close="closebuy">
        <BuyModel @closebuy="closebuy" ref="bm"></BuyModel>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Utils from '../../util/utils'
  import { EventBus } from '../../util/event-bus.js'
  import GoodsListTemp from '../ecomm/GoodsListTemp'
  import BuyModel from './BuyModel'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'AddModel',
    components: {BuyModel, GoodsListTemp},
    data () {
      return {
        modelgroups: [],
        smdialog: true,
        gbpanelvisible: false
      }
    },
    mounted () {
      that = this
      document.title = '功能添加'
      if (getCookie('accesstoken') === null || getCookie('accesstoken') === '') {
        that.$options.methods.getaccesstoken()
      } else {
      }
      that.$options.methods.getmodelgroups()
    },
    methods: {
      closebuy () {
        that.gbpanelvisible = false
        that.$options.methods.getmodelgroups()
        window.clearInterval(localStorage.getItem('interval'))
      },
      getaccesstoken: function () {
        that.$http({
          url: 'https://api.sqnetsoft.cn/wx/getaccesstoken',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              setCookie('accesstoken',res.data.data,7200)
              // 把相关数据缓存到本地
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      getmodelgroups () {
        var qstr = 'id > 0'
        that.$http({
          url: 'https://api.sqnetsoft.cn/permission/gbmg',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              if (res.data.data !== '[]') {
                var tmpdata = JSON.parse(res.data.data)
                window.console.log(tmpdata)
                that.$options.methods.getbuymodels(tmpdata)
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      dateFormat (datestr) {
        var date = new Date(datestr)
        var seperator1 = '/'
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        var hours = date.getHours()
        if (hours >= 0 && hours <= 9) {
          hours = '0' + hours
        }
        var minutes = date.getMinutes()
        if (minutes >= 0 && minutes <= 9) {
          minutes = '0' + minutes
        }
        var seconds = date.getSeconds()
        if (seconds >= 0 && seconds <= 9) {
          seconds = '0' + seconds
        }
        var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        return currentdate
      },
      getbuymodels (tmpdata) {
        var qstr = 'accountid = ' + localStorage.getItem('accountid')
        that.$http({
          url: 'https://api.sqnetsoft.cn/permission/gbmb',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var gtmpdata = JSON.parse(res.data.data)
              var tmparr = []
              for (var i=0; i< tmpdata.length; i++) {
                window.console.log(tmpdata[i])
                for (var j=0; j<gtmpdata.length; j++) {
                  window.console.log(gtmpdata[j])
                  if (tmpdata[i].id.Int64 === parseInt(gtmpdata[j].buymodel.String)) {
                    var data1 = new Date(gtmpdata[j].buytime.String.replace(/-/g, '/'))
                    var date2 = new Date()
                    date2.setDate(data1.getDate() + gtmpdata[j].buymonth * 30);
                    tmpdata[i].buytime = that.dateFormat(date2)
                    tmpdata[i].state = gtmpdata[j].state
                  }
                  // tmparr.push("'" + gtmpdata[j].buymodel.String + "'")
                }
                tmparr.push(tmpdata[i])
              }
              window.console.log('获取已购买模块')
              var addmodels = ''
              for (var k=0; k<gtmpdata.length; k++) {
                if (parseInt(gtmpdata[k].state) === 1) {
                  if (k === gtmpdata.length - 1) {
                    addmodels = addmodels + "'" + gtmpdata[k].buymodel.String + "'"
                  } else {
                    addmodels = addmodels + "'" + gtmpdata[k].buymodel.String + "',"
                  }
                }
              }
              localStorage.setItem('addmodels',addmodels)
              window.console.log(addmodels)
              window.console.log(tmparr)
              that.modelgroups = tmpdata
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      runbuycomm (modeltmpdata,tmpmodels) {
        let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        var adata = {
          accountid: parseInt(localStorage.getItem('accountid')),
          buymodel: {String: '1', Valid: true},
          buytime: {String: addtime, Valid: true},
          state: parseInt(1)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/permission/aaubmb',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.success) {
              localStorage.setItem('models',JSON.stringify(modeltmpdata))
              EventBus.$emit('reloadmenu')
              localStorage.setItem('addmodels',tmpmodels)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      buymodel (tmpid,price,state) {
        if ((parseInt(localStorage.getItem('usergroupid')) === 8 || parseInt(localStorage.getItem('usergroupid')) === 9) && parseInt(localStorage.getItem('userstate')) === 1) {
          if (state === 1) {
            that.$message({
              type: 'info',
              message: '您已经购买'
            })
          } else {
            that.gbpanelvisible = true
            if (price === 0) {
              setTimeout(() => {
                that.$refs.bm.buymodelbyid(tmpid)
              },0)
            } else {
              setTimeout(() => {
                that.$refs.bm.makecode(tmpid,price) // 方法1:触发监听事件
                that.$refs.bm.startorder()
              },0)
            }
          }
        } else {
          that.$message({
            type: 'info',
            message: '账号还未通过审核，无法添加'
          })
        }
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
  function setCookie (name, value, seconds) {
    var d = new Date()
    d.setTime(d.getTime() + 1000 * seconds)
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/model/AddModel.vue